import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';

@Component({
  selector: 'tellent-assistant-tool-call-part',
  standalone: true,
  imports: [TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <span class="pill" [class.error]="status() === 'error'">
      @if (status() === 'running') {
        <span class="spinner"></span>
        {{ 'tlc.tellent_assistant.tool_call.running_status' | translate: { name: name() } }}
      } @else if (status() === 'done') {
        {{
          'tlc.tellent_assistant.tool_call.done_status'
            | translate: { duration: formatDuration(durationMs()) }
        }}
      } @else {
        <span>!</span>
        {{ 'tlc.tellent_assistant.tool_call.error_status' | translate }}
      }
    </span>
  `,
  styleUrls: ['./tool-call-part.component.less'],
})
export class TellentAssistantToolCallPartComponent {
  public readonly name = input.required<string>();
  public readonly status = input.required<'running' | 'done' | 'error'>();
  public readonly durationMs = input<number | null>(null);

  protected formatDuration(ms: number | null | undefined): string {
    if (ms == null) return '0s';
    const s = Math.max(1, Math.round(ms / 1000));
    return `${s}s`;
  }
}
